// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ReactLoadingSkeleton from "react-loading-skeleton";
import ReactLoadingSkeleton$1 from "react-loading-skeleton";
import * as HomeBannerTextCmp$PorterinFeature from "./HomeBannerTextCmp.mjs";
import * as HomeBannerImageCmp$PorterinFeature from "./HomeBannerImageCmp.mjs";
import * as HomeBannerTextCmpV2$PorterinFeature from "./HomeBannerTextCmpV2.mjs";
import * as HomeBannerWrapperModuleScss from "../styles/HomeBannerWrapper.module.scss";

var styles = HomeBannerWrapperModuleScss;

import 'react-loading-skeleton/dist/skeleton.css'
;

function HomeBannerWrapperCmp(Props) {
  var data = Props.data;
  var is_enterprise_v2_enabledOpt = Props.is_enterprise_v2_enabled;
  var is_loadingOpt = Props.is_loading;
  var is_enterprise_v2_enabled = is_enterprise_v2_enabledOpt !== undefined ? is_enterprise_v2_enabledOpt : false;
  var is_loading = is_loadingOpt !== undefined ? is_loadingOpt : false;
  return React.createElement("div", {
              className: "" + styles["banner-wrapper"] + " " + (
                is_enterprise_v2_enabled ? styles["enterprise-v2"] : ""
              ) + ""
            }, React.createElement(HomeBannerImageCmp$PorterinFeature.make, {
                  desktopBanner: data.banner.banner_image.path,
                  mobileBanner: data.banner.banner_img_mobile.path
                }), React.createElement("div", {
                  className: styles["banner-overlay"]
                }), React.createElement("div", {
                  className: styles["desktop-only"]
                }, React.createElement(HomeBannerTextCmp$PorterinFeature.make, {
                      title: data.banner.banner_text,
                      description: data.banner.banner_subtext
                    })), React.createElement("div", {
                  className: styles["mobile-only"]
                }, is_loading ? React.createElement(ReactLoadingSkeleton.SkeletonTheme, {
                        baseColor: "#e6e6e6",
                        highlightColor: "#FEFEFE",
                        duration: 2.0,
                        children: React.createElement(ReactLoadingSkeleton$1, {
                              height: "16rem",
                              containerClassName: styles["skeleton-1"]
                            })
                      }) : React.createElement(React.Fragment, undefined, is_enterprise_v2_enabled ? React.createElement(HomeBannerTextCmpV2$PorterinFeature.make, {
                              title: data.banner.banner_text,
                              description: data.banner.banner_subtext
                            }) : React.createElement(HomeBannerTextCmp$PorterinFeature.make, {
                              title: data.banner.banner_text,
                              description: data.banner.banner_subtext
                            }))));
}

var make = HomeBannerWrapperCmp;

var $$default = HomeBannerWrapperCmp;

export {
  styles ,
  make ,
  $$default ,
  $$default as default,
}
/* styles Not a pure module */
